import React from 'react'

import { css } from '@emotion/core'
import { useCarousel } from 'utils/hooks/useCarousel'
import { useTheme } from 'emotion-theming'

import flexCenter from 'utils/styles/flexCenter'

import Container from 'components/layouts/atoms/Container'
import SectionContainer from 'components/layouts/atoms/SectionContainer'
import Testimony from 'components/common/molecules/Testimony'

import KoinworksTestimonyData from './KoinworksTestimonyData.json'

type Testimony = {
  img?: string
  name: string
  title?: string
  campus?: string
  testimony: string
}

const carouselStyle = (active: number, length: number) => css`
  overflow: hidden;
  position: relative;
  .carousel-content {
    display: flex;
    position: relative;
    width: ${324 * (length + 2)}px !important;
    left: 0 !important;
  }
  .carousel-item {
    width: 324px;
    transform: translateX(-${324 * active}px) scaleX(0.98) scaleY(0.95);
  }
  @media screen and (min-width: 768px) {
    .carousel-content {
      width: ${1190 * (length + 2)}px !important;
      left: 0 !important;
    }
    .carousel-item {
      width: 1190px;
      transform: translateX(-${1190 * active}px) scaleX(0.98) scaleY(0.95);
    }
  }
`

const carouselIndicatorsStyle = (theme: ThemeType) => css`
  ${flexCenter}
  width: 100%;
  bottom: 0;
  position: absolute;
  padding: 12px;
  list-style-type: none;
  li {
    width: 6px;
    height: 6px;
    background-color: ${theme.gray.gray30};
    border-radius: 100%;
    &:not(:last-child) {
      margin-right: 8px;
    }
    &.active {
      width: 16px;
      border-radius: 4px;
      background-color: ${theme.campus.aqua50};
    }
  }
  @media screen and (min-width: 768px) {
    position: unset;
    padding: 0 0;
  }
`

const KoinworksTestimony = () => {
  const theme: ThemeType = useTheme()
  const length = KoinworksTestimonyData?.length || 0
  const [active, setActive, handlers, style] = useCarousel(length, 10000)
  return (
    <div className="koinworks-testimony">
      <SectionContainer backgroundColor={theme.campus.aqua30} withPaddingBottom>
        <Container>
          <div className="carousel" css={carouselStyle(active, length)}>
            <div className="carousel-content" {...handlers} style={style}>
              {KoinworksTestimonyData.map((item, idx) => (
                <div className={`carousel-item ${idx === active ? 'active' : ''}`} key={`testimony-${idx}`}>
                  <Testimony
                    img={item.img && `/next-assets/images/koinworks/testimony/avatar-${item.img}.jpeg`}
                    name={item.name}
                    title={item.title}
                    campus={item.campus}
                    testimony={item.testimony}
                  />
                </div>
              ))}
            </div>
            <ol className="carousel-indicators" css={carouselIndicatorsStyle(theme)}>
              {KoinworksTestimonyData.map((_: Testimony, index: number) => (
                <li
                  onClick={() => setActive(index)}
                  onKeyDown={() => setActive(index)}
                  key={index}
                  className={`${active === index ? 'active' : ''}`}
                />
              ))}
            </ol>
          </div>
        </Container>
      </SectionContainer>
    </div>
  )
}

export default KoinworksTestimony
